






















































import { snakeCase } from 'lodash'
import { ValidationObserver } from 'vee-validate'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import ButtonsManager from '../logic/ButtonsManager'

@Component({
  components: {
    ValidationObserver,
  },
  data() {
    return {
      snakeCase
    }
  }
})
export default class ButtonSettingsView extends Vue {
  @Prop() buttonsManager!: ButtonsManager

  okClick(): void {
    if (this.buttonsManager.selectedButton) {
      this.buttonsManager.updateButton()
    } else {
      this.buttonsManager.createButton()
    }

    this.buttonsManager.unselectButton()
  }

  removeClick(): void {
    this.buttonsManager.removeButton()
    this.buttonsManager.unselectButton()
  }
}
